module.exports = __webpack_public_path__ + "static/media/dk.223faa56.svg";